import { Autocomplete, TextField } from '@mui/material';
import type { AutocompleteProps } from '@mui/material/Autocomplete';
import { extract, withDefault } from '@vy/utils';
import React from 'react';
import { useEventNames } from '../../../../hooks/requests/use-event-names';

type EventNameSelectProps = Omit<AutocompleteProps<string, false, false, true>, 'options' | 'renderInput'> & {
  inputRef?: React.Ref<HTMLInputElement>;
};

export const EventNameSelect: React.FC<EventNameSelectProps> = ({ inputRef, ...props }) => {
  const { data, isLoading } = useEventNames();

  const eventNames = extract(withDefault(data?.eventNames, []), 'eventName');

  return (
    <Autocomplete
      size="small"
      sx={{
        width: '240px',
      }}
      loading={isLoading}
      {...props}
      freeSolo
      autoSelect
      options={eventNames}
      renderInput={(params) => (
        <TextField
          placeholder="Select event name"
          {...params}
          inputRef={inputRef}
          slotProps={{
            ...params.slotProps,

            htmlInput: {
              ...params.slotProps.htmlInput,
              autoComplete: 'new-password',
            }
          }}
        />
      )}
    />
  );
};
